import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import TermsConditions from "../pages/terms-conditions/page";
import CookiePolicy from "../pages/cookie-policy/page";
import ProcessPage from "../pages/process/page";
import PricingPage from "../pages/pricing/page";
import FAQPage from "../pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/process",
    element: <ProcessPage />,
  },
  {
    path: "/pricing",
    element: <PricingPage />,
  },
  {
    path: "/faq",
    element: <FAQPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-conditions",
    element: <TermsConditions />,
  },
  {
    path: "/cookie-policy",
    element: <CookiePolicy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
